module.exports = __webpack_public_path__ + "static/media/az-13.9cb7ac1d.jpg";